"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("@chakra-ui/react");
var _Icon = _interopRequireDefault(require("../Icon"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["alertElementStyles", "children"],
  _excluded2 = ["itemRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Tooltip(_ref) {
  var {
      alertElementStyles,
      children
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var {
      itemRef: _
    } = props,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded2);
  return (0, _jsxRuntime.jsx)(_react.Tooltip, _objectSpread(_objectSpread({
    label: (0, _jsxRuntime.jsxs)(_react.Alert, _objectSpread(_objectSpread({
      background: "transparent",
      paddingLeft: 0
    }, alertElementStyles), {}, {
      children: [extraProps.svg && (0, _jsxRuntime.jsx)(_Icon.default, {
        svg: extraProps.svg,
        mt: extraProps.title && '-20px'
      }), (0, _jsxRuntime.jsxs)(_react.Flex, {
        direction: "column",
        justifyContent: "space-evenly",
        children: [extraProps.title !== 'undefined' && (0, _jsxRuntime.jsx)(_react.Text, {
          ml: "sm",
          fontWeight: "semibold",
          children: extraProps.title
        }), (0, _jsxRuntime.jsx)(_react.Text, {
          ml: "sm",
          children: extraProps.description
        })]
      })]
    }))
  }, extraProps), {}, {
    children: children
  }));
}